import { useState } from 'react'
import { getKyousouApiClient, handleError, ApiErrorResponse } from '../../../../services/network'
import { useSnackBar } from '../../../../providers/snack_bar_provider'
import { SlideThreeC, ThreeCFormData } from './types'
import { AiInstructionFormData } from '../common/types'

export const useThreeCRegenerate = () => {
  const apiClient = getKyousouApiClient()
  const { showSnackBar } = useSnackBar()
  const [isRegenerating, setIsRegenerating] = useState(false)

  const regenerateThreeC = async (
    id: string,
    aiInstruction: string,
    setThreeC: (threeC: SlideThreeC) => void,
    resetAiForm: (data: AiInstructionFormData) => void,
    resetForm: (data: ThreeCFormData) => void
  ) => {
    if (!aiInstruction.trim() || !id) return

    setIsRegenerating(true)

    try {
      const response = await apiClient.business.slideThreecRegenerateCreate({
        businessIdeaId: id,
        aiInstruction: aiInstruction,
      })

      if (response.data?.threeC) {
        setThreeC(response.data.threeC)
        resetAiForm({ aiInstruction: '' })
        showSnackBar(['3C分析のAI再生成が完了しました'], 'success', null) // 自動で消えない

        // フォームの値も更新
        resetForm({
          needs: response.data.threeC.customer.needs,
          targetFirst: response.data.threeC.customer.targetFirst,
          targetSecond: response.data.threeC.customer.targetSecond,
          marketTrendFirst: response.data.threeC.customer.marketTrendFirst,
          marketTrendSecond: response.data.threeC.customer.marketTrendSecond,
          mainCompetitorFirst: response.data.threeC.competitor.mainCompetitorFirst,
          mainCompetitorSecond: response.data.threeC.competitor.mainCompetitorSecond,
          advantageFirst: response.data.threeC.competitor.advantageFirst,
          advantageSecond: response.data.threeC.competitor.advantageSecond,
          differentiationFirst: response.data.threeC.competitor.differentiationFirst,
          differentiationSecond: response.data.threeC.competitor.differentiationSecond,
          strengthFirst: response.data.threeC.company.strengthFirst,
          strengthSecond: response.data.threeC.company.strengthSecond,
          strengthThird: response.data.threeC.company.strengthThird,
          resourceFirst: response.data.threeC.company.resourceFirst,
          resourceSecond: response.data.threeC.company.resourceSecond,
          strategyFirst: response.data.threeC.company.strategyFirst,
          strategySecond: response.data.threeC.company.strategySecond,
          strategyThird: response.data.threeC.company.strategyThird,
        })
      }
    } catch (e) {
      console.error('3C分析のAI再生成に失敗しました:', e)
      handleError(e as ApiErrorResponse, (messages, severity) => {
        showSnackBar(messages, severity, null) // 自動で消えない
      })
    } finally {
      setIsRegenerating(false)
    }
  }

  return {
    isRegenerating,
    regenerateThreeC,
  }
}
